var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalTimesheet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: 1234,
    d: "M3.5 9.99773C3.5 6.40913 6.40913 3.5 9.99773 3.5C10.4119 3.5 10.7477 3.16421 10.7477 2.75C10.7477 2.33579 10.4119 2 9.99773 2C5.5807 2 2 5.5807 2 9.99773C2 14.4147 5.5807 17.9955 9.99773 17.9955C13.6494 17.9955 16.7276 15.5488 17.6863 12.2068C17.8005 11.8086 17.5703 11.3933 17.1721 11.2791C16.774 11.1649 16.3586 11.3951 16.2444 11.7932C15.4654 14.5092 12.9625 16.4955 9.99773 16.4955C6.40913 16.4955 3.5 13.5863 3.5 9.99773ZM12.5926 3.90002C12.5926 3.48581 12.9284 3.15002 13.3426 3.15002H17.2452C17.6594 3.15002 17.9952 3.48581 17.9952 3.90002V7.80265C17.9952 8.21686 17.6594 8.55265 17.2452 8.55265C16.831 8.55265 16.4952 8.21686 16.4952 7.80265V5.71074L10.5281 11.6781C10.2353 11.971 9.76038 11.971 9.46748 11.6781C9.2994 11.51 9.22777 11.282 9.2526 11.0628C9.25088 11.0421 9.25 11.0212 9.25 11V7C9.25 6.58579 9.58579 6.25 10 6.25C10.4142 6.25 10.75 6.58579 10.75 7V9.33484L15.4346 4.65002H13.3426C12.9284 4.65002 12.5926 4.31424 12.5926 3.90002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalTimesheet);
export default __webpack_public_path__ + "static/media/external-timesheet.5c9d859a.svg";
export { ForwardRef as ReactComponent };